/* eslint-disable no-shadow */
export var LOCATION_STATUS_TYPES;
(function (LOCATION_STATUS_TYPES) {
    LOCATION_STATUS_TYPES["ACCEPTED"] = "accepted";
    LOCATION_STATUS_TYPES["DENIED"] = "denied";
    LOCATION_STATUS_TYPES["BLOCKED"] = "blocked";
    LOCATION_STATUS_TYPES["UNAVAILABLE"] = "unavailable";
})(LOCATION_STATUS_TYPES || (LOCATION_STATUS_TYPES = {}));
export const statusMap = {
    accepted: LOCATION_STATUS_TYPES.ACCEPTED,
    denied: LOCATION_STATUS_TYPES.DENIED,
    blocked: LOCATION_STATUS_TYPES.BLOCKED,
    unavailable: LOCATION_STATUS_TYPES.UNAVAILABLE
};
